import {
  AkaGroupLifeCoverage,
  AkaStudentCoverage,
  InsuranceCoverage,
  SpecialInsuranceCoverage,
} from "Store/interfaces/products/coverage";

import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";

export const getMultipleCoverages = (
  coverage?: InsuranceCoverage,
): SpecialInsuranceCoverage[] | undefined => {
  switch (coverage) {
    case AkaStudentCoverage.AKA_STUDENT_STANDARD:
    case AkaStudentCoverage.AKA_STUDENT_ABROAD_AUS:
    case AkaStudentCoverage.AKA_STUDENT_ABROAD_EU:
    case AkaStudentCoverage.AKA_STUDENT_ABROAD_NOR:
    case AkaStudentCoverage.AKA_STUDENT_ABROAD_OTHER:
    case AkaStudentCoverage.AKA_STUDENT_ABROAD_USA:
      return [
        SpecialInsuranceCoverage.AKA_STUDENT_TRAVEL,
        SpecialInsuranceCoverage.AKA_STUDENT_HOUSE_CONTENTS,
      ];
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_ALL:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_ALL_AND_CO_ALL:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_ALL_AND_CO_DEATH:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_ALL_AND_CO_INCAP:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_ALL_AND_CO_DEATH_AND_INCAP:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_ALL_AND_CO_INCAP_AND_TIME:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_ALL_CO:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH_AND_CO_ALL:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH_AND_CO_DEATH_AND_INCAP:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH_AND_CO_INCAP:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH_AND_CO_INCAP_AND_TIME:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH_AND_INCAP:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH_AND_INCAP_CO:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_CO_DEATH:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_CO_DEATH_AND_INCAP:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_ALL:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_DEATH:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_DEATH_AND_INCAP:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_INCAP:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_INCAP_AND_TIME:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_ALL:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_DEATH:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_DEATH_AND_INCAP:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_CO_ALL:
      return [
        SpecialInsuranceCoverage.AKA_GROUP_LIFE_DEATH,
        SpecialInsuranceCoverage.AKA_GROUP_LIFE_INCAP,
      ];
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH_AND_CO_DEATH:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH_CO:
      return [SpecialInsuranceCoverage.AKA_GROUP_LIFE_DEATH];
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_CO_INCAP:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_CO_INCAP_AND_TIME:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_TIME:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_INCAP:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_INCAP_AND_TIME:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_TIME_CO:
    case AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_CO:
      return [SpecialInsuranceCoverage.AKA_GROUP_LIFE_INCAP];
    default:
      return undefined;
  }
};

export type IpidKeyType =
  | INSURANCE_NAME_VALUE
  | InsuranceCoverage
  | SpecialInsuranceCoverage
  | undefined;
